/**
 * Custom DateField component that should be used instead of React-Admin's default DateField.
 * This component ensures consistent timezone handling across the application by using the timezone context.
 *
 */
import React from "react";
import { DateField as RaDateField } from "react-admin";
import { useTimezone } from "~/hooks/timezone.tsx";

type TimezoneDateFieldProps = {
	source: string;
	showTime?: boolean;
	label?: string;
	sortable?: boolean;
};

function TimezoneDateField({
	source,
	showTime,
	label,
	sortable,
	...props
}: TimezoneDateFieldProps) {
	const timezone = useTimezone();

	return (
		<RaDateField
			source={source}
			showTime={showTime}
			label={label}
			sortable={sortable}
			options={{
				timeZone: timezone,
			}}
			{...props}
		/>
	);
}

export default TimezoneDateField;
